import * as React from "react";
import { toast } from "@grandvisionhq/common";
import { Util } from "@grandvisionhq/forms";
import { useReturnFormState } from "./use-return-form-state.js";
import { useReturnSubmission } from "./use-return-submission.js";
import { useReturnValidation } from "./use-return-validation.js";
const useReturnItemsForm = ({
  email,
  orderNumber,
  lineItems = [],
  returnReasons
}) => {
  const { formState, setFormState } = useReturnFormState(lineItems);
  const { isAnyCheckboxChecked, validateForm } = useReturnValidation();
  const { submit, loading } = useReturnSubmission({
    email,
    orderNumber,
    lineItems,
    returnReasons
  });
  const submitForm = React.useCallback(
    async ({ formState: formState2 }) => {
      if (!lineItems || lineItems.length === 0) {
        console.error(`Can't submit returns form without line items for order ${orderNumber}`);
        return;
      }
      const validation = validateForm(formState2);
      if (!validation.isValid) {
        toast.failed(validation.error);
        setFormState(formState2);
        return;
      }
      const values = Util.getValuesFromState(formState2);
      await submit(values);
    },
    [lineItems, orderNumber, validateForm, setFormState, submit]
  );
  const triggers = React.useMemo(
    () => ({ isAnyCheckboxChecked, submitForm }),
    [isAnyCheckboxChecked, submitForm]
  );
  const state = React.useMemo(() => ({ formState, loading }), [formState, loading]);
  return React.useMemo(() => [triggers, state], [triggers, state]);
};
export {
  useReturnItemsForm
};
//# sourceMappingURL=use-return-items-form.js.map
